// authService.js
import api from './api';

export const validateToken = async () => {
    try {
        const token = sessionStorage.getItem('authToken');
        const user = sessionStorage.getItem('user');
        const currPath = (window.location.pathname === "/login")  
        
        if(!token){
            console.log('no hay token');
            return null;
        }else {
            console.log('si hay token:', token,'   -- user: ', user);
        }

        const response = await api.get('/validate'); // Llama al backend para validar el token

       
        const userData = response.data; 

        console.log("validate response ", userData);

        console.log("currPath >>",currPath ," -- userData:",userData );     
        if(currPath && userData){
            const response1 = await api.get('/'); // Llama al backend para validar el token
            console.log("get user from  /api/ ",response1);

            const userData1 = response1.data; 
 
            if(userData1){
                sessionStorage.setItem('user', JSON.stringify(userData1.user));
                sessionStorage.setItem('authToken', userData1.token);
                
            }
            return false;
        }
        // Guardamos la información del usuario en sessionStorage
         

        return userData;
    } catch (error) {
        console.error('Error al validar el token:', error);
        return null;
    }
};
